import { render, staticRenderFns } from "./WindowMain.vue?vue&type=template&id=8a3d5688&scoped=true"
import script from "./WindowMain.vue?vue&type=script&lang=js"
export * from "./WindowMain.vue?vue&type=script&lang=js"
import style0 from "./WindowMain.vue?vue&type=style&index=0&id=8a3d5688&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3d5688",
  null
  
)

export default component.exports